import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../styles/Header.css';

interface HeaderProps {
  title: string;
  showBackButton?: boolean;
}

const Header: React.FC<HeaderProps> = ({ title, showBackButton = false }) => {
  const navigate = useNavigate();

  return (
    <header className="header fixed-header">
      <div className="header-content">
        <div className="header-left">
          {showBackButton && (
            <button className="back-button" onClick={() => navigate(-1)}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
          )}
          <img 
            src="/images/logo2024.png" 
            alt="Logo" 
            className="header-logo" 
            onClick={() => navigate('/')}
          />
        </div>
        <h1 className="header-title">{title}</h1>
      </div>
    </header>
  );
};

export default Header; 